var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypography = function SvgTypography(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "typo_a",
    d: "M25.31 41.775l-2.38-.893 6.734-17.956a2.966 2.966 0 0 1 5.555 0l6.733 17.956-2.38.893-6.734-17.957a.424.424 0 0 0-.794 0l-6.733 17.957zm-3.039.825a1.271 1.271 0 0 1 0-2.542h4.623a1.271 1.271 0 1 1 0 2.542h-4.623zm15.717 0a1.271 1.271 0 0 1 0-2.542h4.623a1.271 1.271 0 0 1 0 2.542h-4.623zm-11.094-7.396a1.271 1.271 0 1 1 0-2.543h10.17a1.271 1.271 0 1 1 0 2.543h-10.17z"
  })));
};
export default SvgTypography;